module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Color-Collection-Video.f1bf43d4.webp";